import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintEdi_ds_uom_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { owner?: string, project?: string, material?: string, uom?: string, full_text_search?: string, $top?: number, $skip?: number }): Promise<{ result?: { project?: string, owner?: string, material?: string, uom?: string, sub_uom?: string, sub_quantity?: number, base_uom?: string, base_quantity?: number, is_default?: boolean, modified_by?: string, modified_on?: string, uom_id?: string }[], totalCount?: number }> {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { owner?: string, project?: string, material?: string, uom?: string, full_text_search?: string, $keys: string[] }): Promise<{ result?: { project?: string, owner?: string, material?: string, uom?: string, sub_uom?: string, sub_quantity?: number, base_uom?: string, base_quantity?: number, is_default?: boolean, modified_by?: string, modified_on?: string, uom_id?: string }[] }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      owner?: string, project?: string, material?: string, uom?: string, full_text_search?: string    }) {
      return false;
    }
}
